'use strict'

module.exports = trimLines

var ws = /[ \t]*\n+[ \t]*/g
var newline = '\n'

function trimLines(value) {
  return String(value).replace(ws, newline)
}



//////////////////
// WEBPACK FOOTER
// ./~/trim-lines/index.js
// module id = 1038
// module chunks = 95715928098905 168707334958949